const weightOrZero = (weight) => {
    const value = weight == null || weight === '' ? 0 : Number(weight);
    return Number.isFinite(value) ? value : 0;
}

const applyManifestToRoutes = (routes, shareManifest) => routes?.map(route => {
    const manifest = shareManifest && routes?.length > 0 ? routes[0].manifest : route.manifest;

    if (manifest && manifest.length) {
        route.passengerNumber = manifest.length;
        route.totalWeight = manifest.reduce((total, passenger) => total
            + weightOrZero(passenger.freightWeight)
            + weightOrZero(passenger.cargoWeight)
            + weightOrZero(passenger.passengerWeight), 0);
    }

    route.manifest = manifest;
    return route;
});

export { applyManifestToRoutes };